import React from "react";
import { Grid } from "@material-ui/core";
import { Accordion } from "@packages/ui";

const PersonalInfoForm = () => {
  return (
    <Grid container direction="row" justify="center" alignItems="center" style={{ marginTop: 50 }}>
      <Grid item xs={6}>
        <Accordion key={1} />
        <Accordion key={2} />
      </Grid>
    </Grid>
  );
};

export default PersonalInfoForm;
